import {usePageContext} from "vike-react/usePageContext";
import {AppPageContext} from "#/src/definitions/AppDefinitions";

export function Header() {
  const {urlPathname} = usePageContext() as AppPageContext;
  return <header className="profil-header">
    <div className="container-xxl">
      <div className="row">
        <div className="col-xl-12">
          {urlPathname.startsWith("/my-profile") ? <h2>Twój profil</h2> : <h2>Profil</h2>}
        </div>
      </div>
    </div>
  </header>
}